/**
 * @description - provides access to the systems domain in a readyonly fashion
 * @returns {string}
*/
export const domain = () => window.LibraryAware ? window.LibraryAware.ShortUrlBase : "undefined";

/**
 * @description - provides access to the systems base path (with orgId) in a readyonly fashion
 * @returns {string}
*/
export const baseURL = () => window.LibraryAware ? window.LibraryAware.Path : "/undefined";

/**
 * @description - provides access to the systems web root in a readyonly fashion
 * @returns {string}
*/
export const webRoot = () => window.LibraryAware ? window.LibraryAware.WebRoot : "/";

/**
 * @description - provides access to the systems organization id to be used as a base level url path
 * @returns {string}
*/
export const orgRootURL = () =>
{
    let orgVal = window.LibraryAware ? window.LibraryAware.OrganizationId : "undefined";

    return `/${orgVal}`; 
}
